import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const NOW = () => {
  return (
    <CardSection id="NOW" title="NOW">
      <Paragraph>현재 날짜와 시간을 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>NOW()</Paragraph>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>NOW()</Paragraph>
        <Img src="computeNow" />
      </ListSection>

      {/* 
  <ListSection title="Notes on use">
    <Paragraph>
      함수에 시간대가 지정되지 않은 경우 반환된 datetime 객체는 기본적으로
      그리니치 표준시(GMT)로 설정됩니다. 시간대 목록과 적절한 구문은{" "}
      <a
        onClick={() => {
          window.open("/#/manual?key=project.computedColsTool", "_blank");
        }}
      >
        Date and Time Syntax
      </a>{" "}
      문서를 참조하세요.
    </Paragraph>
  </ListSection>
  */}
    </CardSection>
  );
};
